const FREQUENCY_PRESETS = [
  {
    maxYears: 20,
    label: '20年一遇',
    peakFlow: 5200,
    inflowFactor: 1,
    releaseFactor: 1,
    levelLift: 0,
    levelResponse: 1,
    areaFactor: 1,
    peakReductionDelta: 0,
    riskShift: 0,
  },
  {
    maxYears: 50,
    label: '50年一遇',
    peakFlow: 6400,
    inflowFactor: 1.22,
    releaseFactor: 1.16,
    levelLift: 0.34,
    levelResponse: 1.05,
    areaFactor: 1.45,
    peakReductionDelta: -4,
    riskShift: 1,
  },
  {
    maxYears: 100,
    label: '100年一遇',
    peakFlow: 7600,
    inflowFactor: 1.46,
    releaseFactor: 1.32,
    levelLift: 0.78,
    levelResponse: 1.08,
    areaFactor: 2.05,
    peakReductionDelta: -8,
    riskShift: 2,
  },
  {
    maxYears: 500,
    label: '500年一遇',
    peakFlow: 10200,
    inflowFactor: 1.96,
    releaseFactor: 1.64,
    levelLift: 1.72,
    levelResponse: 1.16,
    areaFactor: 3.65,
    peakReductionDelta: -16,
    riskShift: 3,
  },
  {
    maxYears: Infinity,
    label: '1000年一遇',
    peakFlow: 11800,
    inflowFactor: 2.25,
    releaseFactor: 1.82,
    levelLift: 2.18,
    levelResponse: 1.2,
    areaFactor: 4.7,
    peakReductionDelta: -20,
    riskShift: 4,
  },
]

const RISK_LEVELS = ['低风险', '中风险', '较高风险', '高风险', '极高风险']

function round(value, digits = 1) {
  const base = Math.pow(10, digits)
  return Math.round(Number(value) * base) / base
}

export function floodFrequencyYears(frequency = '') {
  const text = String(frequency)
  const numeric = text.match(/(\d{1,4})\s*年/)
  if (numeric) return Number(numeric[1])
  if (/千年|1000/.test(text)) return 1000
  if (/五百年|500/.test(text)) return 500
  if (/百年|100/.test(text)) return 100
  if (/五十年|50/.test(text)) return 50
  if (/二十年|20/.test(text)) return 20
  return 20
}

export function getFloodFrequencyConfig(frequency = '20年一遇') {
  const years = floodFrequencyYears(frequency)
  const preset = FREQUENCY_PRESETS.find(item => years <= item.maxYears) || FREQUENCY_PRESETS[0]
  return {
    ...preset,
    years,
    label: `${years}年一遇`,
  }
}

function shiftRisk(baseRisk, shift) {
  const baseIndex = Math.max(0, RISK_LEVELS.indexOf(baseRisk))
  return RISK_LEVELS[Math.min(RISK_LEVELS.length - 1, baseIndex + shift)]
}

export function scaleFloodSchemeForFrequency(scheme, frequency = '20年一遇') {
  const config = getFloodFrequencyConfig(frequency)
  const timeline = scheme.timeline || {}
  const levelBase = 616
  const scaledTimeline = {
    time: timeline.time || [],
    inflow: (timeline.inflow || []).map(value => round(value * config.inflowFactor, 0)),
    release: (timeline.release || []).map(value => round(value * config.releaseFactor, 0)),
    level: (timeline.level || []).map(value => round(levelBase + (value - levelBase) * config.levelResponse + config.levelLift, 2)),
    area: (timeline.area || []).map(value => round(Math.max(0.08, value * config.areaFactor), 2)),
  }
  const maxRelease = Math.max(...scaledTimeline.release, 0)
  const maxLevel = Math.max(...scaledTimeline.level, scheme.maxLevel || 0)
  const maxArea = Math.max(...scaledTimeline.area, scheme.inundationArea || 0)
  return {
    ...scheme,
    risk: shiftRisk(scheme.risk, config.riskShift),
    peakFlow: config.peakFlow,
    peakRelease: maxRelease,
    maxLevel,
    peakReduction: Math.max(8, round((scheme.peakReduction || 30) + config.peakReductionDelta, 0)),
    inundationArea: maxArea,
    frequencyLabel: config.label,
    condition: `${config.label}洪水，${scheme.condition}`,
    description: `${scheme.description} ${config.label}工况下洪峰和淹没范围已按演示模型放大。`,
    expertComment: `${scheme.expertComment}${config.years >= 100 ? ` 在${config.label}条件下，下游水位涨率和漫滩范围明显放大，应同步提高预警响应等级。` : ''}`,
    timeline: scaledTimeline,
  }
}
